import React from "react";
import "../styles/StaffInfo.css";

const staffData = [
  {
    name: "মোঃ শাহদাৎ হোসেন",
    designation: "প্রধান শিক্ষক",
    department: "প্রশাসনিক",
    phone: "১৭৩২৭৩১৭৭৫",
    email: "shahdat@akijinsaf.com",
    photo: require("../Assets/Images/shahdat.jpg"),
  },
  {
    name: "মোঃ হাসান আলী ",
    designation: "সহকারী প্রধান শিক্ষক",
    department: "প্রশাসনিক",
    phone: "১৮১৪২৪০৬৮৭",
    email: "hasan.ali@akijinsaf.com",
    photo: require("../Assets/Images/hasan.ali.jpg"),
  },
  {
    name: "মোঃ নাফি উদ্দীন",
    designation: "সিনিয়র প্রশিক্ষক",
    department: "রেফ্রিজারেশন এন্ড এয়ারকন্ডিশনিং",
    phone: "১৭৬২৭০৯৬৭৪",
    email: "nafi@akijinsaf.com",
    photo: require("../Assets/Images/nafi.jpg"),
  },
  
  {
    name: "মোঃ মিজানুর রহমান মিজান ",
    designation: "প্রশিক্ষক",
    department: "অটোমোবাইল",
    phone: "১৭০৬৫০৩৪৫৬",
    email: "md.mizanur@akijinsaf.com",
    photo: require("../Assets/Images/md.mizanur.jpg"),
  },
  {
    name: "মোঃ নুর আলম ",
    designation: "প্রশিক্ষক",
    department: "ইলেক্ট্রিক্যাল",
    phone: "১৭৭০৯৫০৪৪০",
    email: "nuralom@akijinsaf.com",
    photo: require("../Assets/Images/nuralom.jpg"),
  },
  {
    name: "মোঃ শামীম মিয়া ",
    designation: "প্রশিক্ষক",
    department: "ইলেক্ট্রিক্যাল",
    phone: "১৮২৭৬১৬২৬৫",
    email: "shamim@akijinsaf.com",
    photo: require("../Assets/Images/shamim.jpg"),
  },
  {
    name: "মোঃ এ কে আজাদ ",
    designation: "প্রশিক্ষক",
    department: "কম্পিউটার ",
    phone: "১৬০০০০৫৯৫৯",
    email: "ak.azad@akijinsaf.com",
    photo: require("../Assets/Images/ak.azad.jpg"),
  },
  {
    name: "কে এম রাকিব ",
    designation: "প্রশিক্ষক",
    department: "কম্পিউটার",
    phone: "১৭৯৬৭৪২৬১৬",
    email: "km.rakib@akijinsaf.com",
    photo: require("../Assets/Images/km.rakib.jpg"),
  },
  {
    name: "মোঃ ওবায়দুর রহমান ",
    designation: "শিক্ষক",
    department: "বিজ্ঞান",
    phone: "১৭৪৪৪৮৯৮৩১",
    email: "obaidur@akijinsaf.com",
    photo: require("../Assets/Images/obaidur.jpg"),
  },
 
  {
    name: "মোঃ রেজাউল কবির  ",
    designation: "শিক্ষক",
    department: "ইংরেজী",
    phone: "১৬৮১০৬৫৪০৬",
    email: "rezaul.kabir@akijinsaf.com",
    photo: require("../Assets/Images/rezaul.kabir.jpg"),
  },
  {
    name: " ",
    designation: "শিক্ষক",
    department: "বাংলা",
    phone: "",
    email: "@akijinsaf.com",
    // photo: require("../Assets/Images/staff/shahdat.jpg"),
  },
  {
    name: " ",
    designation: "শিক্ষক",
    department: "গনিত",
    phone: "",
    email: "@akijinsaf.com",
    // photo: require("../Assets/Images/staff/shahdat.jpg"),
  },
  {
    name: " ",
    designation: "শিক্ষক",
    department: "ধর্ম",
    phone: "",
    email: "@akijinsaf.com",
    // photo: require("../Assets/Images/staff/shahdat.jpg"),
  },
  {
    name: " ",
    designation: "প্রশিক্ষক",
    department: "শারিরিক শিক্ষা",
    phone: "",
    email: "@akijinsaf.com",
    // photo: require("../Assets/Images/staff/shahdat.jpg"),
  },
  {
    name: "মোঃ মানিক হাসান ",
    designation: "ল্যাব সহকারী",
    department: "ইলেক্ট্রিক্যাল",
    phone: "১৮১৮৬২২৪১৫",
    email: "manikhasan@akijinsaf.com",
    photo: require("../Assets/Images/manikhasan.jpg"),
  },
  {
    name: "মোঃ বায়েজিদ বোস্তামী",
    designation: "ল্যাব সহকারী",
    department: "রেফ্রিজারেশন এন্ড এয়ারকন্ডিশনিং",
    phone: "১৭৫০১৪১১৮৭",
    email: "bayejid@akijinsaf.com",
    photo: require("../Assets/Images/bayejid.jpg"),
  },
  {
    name: "মোঃ রেজাউল ইসলাম",
    designation: "হিসাবরক্ষক",
    department: "হিসাব",
    phone: "১৭৬১৯৭৪৩২০",
    email: "md.rezaul@akijinsaf.com",
    photo: require("../Assets/Images/md.rezaul.jpg"),
  },
  {
    name: "মোঃ রাজু রানা ",
    designation: "অফিস সহকারী",
    department: "প্রশাসনিক",
    phone: "১৯২০৭৪৩৮৬৫",
    email: "@akijinsaf.com",
    photo: require("../Assets/Images/raju.jpg"),
  },
  {
    name: " ",
    designation: "সহকারী কাম মালি",
    department: "প্রশাসনিক",
    phone: "",
    email: "@akijinsaf.com",
    // photo: require("../Assets/Images/staff/shahdat.jpg"),
  },
  {
    name: "মোঃ আবু রায়হান ",
    designation: "নিরাপত্তা প্রহরী",
    department: "প্রশাসনিক",
    phone: "১৭৯৭৫৬৬১৭৪",
    email: "@akijinsaf.com",
    // photo: require("../Assets/Images/staff/shahdat.jpg"),
  },
  {
    name: "মুফতী হাসিবুল ইসলাম ",
    designation: "সিনিয়র শিক্ষক",
    department: "ইসলাম",
    phone: "০১৯৩৩১৪৮২৬৬",
    email: "raselmiah@akijinsaf.com",
    photo: require("../Assets/Images/hasibul.jpg"),
  },

   {
    name: "মো: ফরিদুল ইসলাম",
    designation: "সিনিয়র শিক্ষক",
    department: "বাংলা",
    phone: "০১৭৪৯১২১১৬১",
    email: "faridul@akijinsaf.com",
    photo: require("../Assets/Images/faridul.jpg"),
  },
  {
    name: "মোঃ মাসুদুর রহমান",
    designation: " শিক্ষক",
    department: "গণিত",
    phone: "০১৯৬৫৪০২০০৯",
    email: "md.masudur@akijinsaf.com",
    photo: require("../Assets/Images/masudur.jpg"),
  },
  {
    name: "মোঃ আব্দুল আলীম খান",
    designation: " শিক্ষক",
    department: "রসায়ন",
    phone: "০১৫৭২১৪৯৫৪৮",
    email: "",
    photo: require("../Assets/Images/alim.jpg"),
  },
  {
    name: "মো‌‍‍: শাহারিয়ার কবির",
    designation: " ল্যাব সহকারী",
    department: "কম্পিউটার",
    phone: "০১৯১১৭৬৭৬৭২",
    email: "shahariar@akijinsaf.com",
    photo: require("../Assets/Images/shahariar.jpg"),
  },
  {
    name: "মোঃ মহিউদ্দিন",
    designation: " সহকারী,কাম মালী",
    department: "প্রশাসনিক",
    phone: "০১৭১৭৩২০৫৩৩",
    email: "",
    photo: require("../Assets/Images/mohiuddin.jpg"),
  },
  {
    name: "মোঃকালাম শেখ",
    designation: " পরিছন্নতা কর্মী /ক্লিনার",
    department: "প্রশাসনিক",
    phone: "০১৭৪৬৭৮৫৫২৮",
    email: "",
    photo: require("../Assets/Images/kalam.jpg"),
  },

  {
    name: "মোঃনয়ন শরিফ",
    designation: " পরিছন্নতা কর্মী /ক্লিনার",
    department: "প্রশাসনিক",
    phone: "০১৭৩১৭৮৮৮৫৭",
    email: "",
    photo: require("../Assets/Images/noyon.jpg"),
  },

  {
    name: "মোঃজুবায়ের আহমেদ ",
    designation: " সহকারী বাবুর্চি",
    department: "প্রশাসনিক",
    phone: "০১৮৭৭৩৩৮২৬৯",
    email: "",
    photo: require("../Assets/Images/zubayer.jpg"),
  },

   {
    name: "মো‌‍‍:জাকির হোসেন",
    designation: " হাবিলদার",
    department: "প্রশাসনিক",
    phone: "০১৭১৬৮৬৯৭৭৯",
    email: "",
    photo: require("../Assets/Images/zakir.jpg"),
  },

  {
    name: "মো‌‍‍:শফিকুল ইসলাম",
    designation: " নিরাপত্তা প্রহরী",
    department: "প্রশাসনিক",
    phone: "০১৬০২২৭৩২২৫",
    email: "",
    photo: require("../Assets/Images/shofiqul.jpg"),
  },

  {
    name: "মো‌‍‍:মহিবুল্লাহ",
    designation: " নিরাপত্তা প্রহরী",
    department: "প্রশাসনিক",
    phone: "০১৬২০৯৬৩৯৭৮",
    email: "",
    photo: require("../Assets/Images/mohibullah.jpg"),
  },
   {
    name: "মোঃকাওসার আহম্মেদ",
    designation: " সহকারী বাবুর্চি",
    department: "প্রশাসনিক",
    phone: "০১৩৪৫-১০৭৭৯১",
    email: "",
    photo: require("../Assets/Images/kawser.jpg"),
  },
];

export default function StaffInfo() {
  return (
    <div className="staff-page">
      <h2 className="section-title">Staff Information</h2>

      <table className="staff-table">
        <thead>
          <tr>
            <th>ক্র. নং</th>
            <th>কর্মকর্তা/কর্মচারীর নাম</th>
            <th>পদবী</th>
            <th>বিভাগ</th>
            <th>মোবাইল নম্বর</th>
            <th>ইমেইল</th>
            <th>ছবি</th>
          </tr>
        </thead>

        <tbody>
          {staffData.map((staff, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{staff.name}</td>
              <td>{staff.designation}</td>
              <td>{staff.department}</td>
              <td>{staff.phone}</td>
              <td>
                <a href={`mailto:${staff.email}`} className="email-link">
                  {staff.email}
                </a>
              </td>
              <td>
                {staff.photo ? (
                  <img
                    src={staff.photo}
                    alt={staff.name}
                    className="staff-photo"
                  />
                ) : (
                  <span className="no-photo">No Photo</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
